<template>
  <div></div>
</template>

<script>
import { mapMutations } from "vuex";
import firebase from "../firebase/firebase";

export default {
  created() {
    //Logout and open the login screen
    var vm = this;
    //#TODO revisit this area with async/await
    firebase
      .auth()
      .signOut()
      .then(function() {
        // Sign-out successful.
        var payload = {
          user: null,
          login_time: null,
          role: null,
          token: null,
          home: true,
          login: false
        };
        vm.$store.commit("_logout", payload);
        localStorage.setItem("state", JSON.stringify(vm.$store.state));

        vm.$router.push({ name: "Login" });
      })
      .catch(function(error) {
        // An error happened.
        console.log("Unable to signout! with " + error);
      });
  },
  methods: {
    ...mapMutations([
      // maps `this._logout()` to `this.$store.commit('_logout')`
      "_logout"
    ])
  }
};
</script>
